import React, { useEffect, useState } from "react";
import Header from "../newinterface/header";
import BlogHeader from "../newinterface/blogHeader";
import Footer from "../newinterface/footer";
import locationService from "../../../services/locationService";
import SuiteFaq from "./suiteFaq.json";
import GeneralFaq from "./generalFaq.json";
// import starbucksLogo from "../../../public/assets/newUI-images/starbucks/SSC-Shuttle-Schedule.pdf";

function StartBucksIntership() {
  const [state, setState] = useState({
    latitude: 0.0,
    longitude: 0.0,
    communityObject: [],
    communityImages: [],
    communityAmenities: [],
    showlist: false,
    showSearch: false,
    directionsService: {},
    directionsDisplay: {},
    destinationAdd: "",
    types: [
      {
        name: "Restaurants",
        type: "restaurant",
        fa: "fas fa fa-cutlery",
        icon: "/assets/newUI-images/explore_icons/restarent.svg",
      },
      {
        name: "Bars",
        type: "bar",
        fa: "fas fa fa-beer",
        icon: "/assets/newUI-images/explore_icons/bars.svg",
      },
      {
        name: "Groceries",
        type: "supermarket",
        fa: "fas fa fa-shopping-cart",
        icon: "/assets/newUI-images/explore_icons/groceries.svg",
      },
      {
        name: "Park",
        type: "park",
        fa: "fas fa fa-tree",
        icon: "/assets/newUI-images/explore_icons/parks.svg",
      },
      {
        name: "Shopping",
        type: "shopping_mall",
        fa: "fas fa fa-shopping-bag",
        icon: "/assets/newUI-images/explore_icons/shopping.svg",
      },
      {
        name: "Entertainment",
        type: "night_club",
        fa: "fas fa fa-film",
        icon: "/assets/newUI-images/explore_icons/entertainment.svg",
      },
    ],
    type: "restaurant",
    activeNumber: -1,
    location: [],
    generalTab: false,
  });

  useEffect(() => {
    window.onbeforeunload = function () {
      window.scrollTo(0, 0);
    };

    var link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.getElementsByTagName("head")[0].appendChild(link);
    }
    link.href =
      "https://suiteam-website.s3.us-west-1.amazonaws.com/new/logo/SA-Icon.png";
    getPropertyData();
  }, []);

  useEffect(() => {
    if (state.communityObject) {
      if (typeof window.google === "undefined") {
        const interval = setInterval(() => {
          if (typeof window.google !== "undefined") {
            clearInterval(interval);
            methodx(); // Call your function when Google Maps is available
          }
        }, 100); // Check every 100ms
      } else {
        methodx(); // Already loaded
      }
    }
  }, [state.communityObject]);

  const updateState = (updateObj) => {
    setState((prev) => ({ ...prev, ...updateObj }));
  };
  const getPropertyData = async () => {
    try {
      var communityName = "Level Seattle";
      // var communityName = "THE NOLO";
      let reqObject = {
        communityName: encodeURIComponent(encodeURIComponent(communityName)),
        imageType: "banner",
      };
      // console.log(reqObject, "reqObject");

      const response = await locationService.getCommunityInfoByName(reqObject);
      // console.log(response, "response");
      updateState({
        communityObject: response,
        latitude: response.latitude,
        longitude: response.longitude,
      });

      await getImages(response);
      await getAmenities(response);
    } catch (error) {
      console.log(error, "error");
    }
  };

  const getImages = (data) => {
    try {
      let communityImages =
        data.CommunityImages != null && data.CommunityImages != undefined
          ? JSON.parse(data.CommunityImages)
          : [];
      if (data.CommunityImages != null && data.CommunityImages != undefined) {
        communityImages.unshift({
          image_name: data.image_name,
        });
      }
      updateState({ communityImages: communityImages });
    } catch (error) {
      console.log(error, "error");
    }
  };
  const getAmenities = (data) => {
    try {
      const appartmentAmenities =
        data.AmenitiesList != null && data.AmenitiesList != undefined
          ? JSON.parse(data.AmenitiesList)
          : [];
      // console.log(appartmentAmenities, "appartmentAmenities");

      updateState({ communityAmenities: appartmentAmenities });
    } catch (error) {
      console.log(error, "error");
    }
  };

  const CustomZoomInControl = (controlDiv, map) => {
    // Set CSS for the control border
    var controlUI = document.createElement("div");

    controlUI.style.cursor = "pointer";
    controlUI.style.display = "-webkit-inline-box";
    controlUI.style.margin = "18px 10px";
    controlUI.style.width = "30px";
    controlUI.style.height = "30px";
    controlDiv.appendChild(controlUI);
    // Set CSS for the control interior
    var controlText = document.createElement("div");
    controlText.innerHTML += `<img style="height:30px;width:30px;margin:0"  src='/assets/newUI-images/plus.svg' />`;
    controlUI.appendChild(controlText);

    // Setup the click event listeners
    google.maps.event.addDomListener(controlUI, "click", function () {
      map.setZoom(map.getZoom() + 1);
    });

    // Set CSS for the control border
    var controlUILeft = document.createElement("div");

    controlUILeft.style.display = "-webkit-inline-box";
    controlUILeft.style.marginLeft = "10px";
    controlUILeft.style.cursor = "pointer";
    controlUILeft.style.width = "30px";
    controlUILeft.style.height = "30px";
    controlDiv.appendChild(controlUILeft);

    var controlTextLeft = document.createElement("div");

    controlTextLeft.innerHTML += `<img style="height:30px;width:30px;margin:0"  src='/assets/newUI-images/minus.svg' />`;
    controlUILeft.appendChild(controlTextLeft);

    // Setup the click event listeners
    google.maps.event.addDomListener(controlUILeft, "click", function () {
      map.setZoom(map.getZoom() - 1);
    });
  };

  const methodx = async () => {
    if (state.markerList && state.markerList.length > 0) {
      state.markerList.forEach((marker) => marker.setMap(null));
      updateState({ markerList: [] });
    }
    updateState({
      directionsService: {},
      directionsDisplay: {},
      destinationAdd: "",
    });
    document.getElementById("dvDistance").innerHTML = "";
    $("#txtPlaces").val("");
    if ($("#map" + state.communityObject.community_id).length) {
      var locations = {
        lat: Number(state.communityObject.latitude),
        lng: Number(state.communityObject.longitude),
      };
      console.log(locations, "locations");

      const map = new google.maps.Map(
        document.getElementById("map" + state.communityObject.community_id),
        {
          zoom: 7,
          center: locations,
          mapTypeId: google.maps.MapTypeId.ROADMAP,
          backgroundColor: "#eeeeee",
          disableDefaultUI: true,
        }
      );
      var style = [
        {
          elementType: "geometry",
          stylers: [{ saturation: -40 }],
        },
      ];
      var mapType = new google.maps.StyledMapType(style, { name: "Grayscale" });
      map.mapTypes.set("grey", mapType);
      map.setMapTypeId("grey");
      var customZoomInControlDiv = document.createElement("div");
      CustomZoomInControl(customZoomInControlDiv, map);
      customZoomInControlDiv.index = 1;
      map.controls[google.maps.ControlPosition.LEFT_BOTTOM].push(
        customZoomInControlDiv
      );
      updateState({ customMap: map });

      var directionsService = new google.maps.DirectionsService();
      var directionsDisplay = new google.maps.DirectionsRenderer();

      updateState({ directionsService: directionsService });
      updateState({ directionsDisplay: directionsDisplay });
      const image_name = state.communityObject.image_name;
      const communityName = state.communityObject.community_name;
      const communityAddress = state.communityObject.address;
      const communityLat = state.communityObject.latitude;
      const communityLong = state.communityObject.longitude;
      const communityCity = state.communityObject.city_name;
      const communityState = state.communityObject.state_name;
      const communityZipcode = state.communityObject.ZipCode;
      const detailAddress =
        communityAddress +
        ", " +
        communityCity +
        ", " +
        communityState +
        " " +
        communityZipcode;
      var locations = {
        lat: Number(communityLat),
        lng: Number(communityLong),
      };
      var contentString =
        '<div id="content">' +
        '<div id="siteNotice">' +
        "</div>" +
        '<div id="bodyContent">' +
        '<div class="bodycontentimg"><img width="100px" height="100px" src="' +
        image_name +
        '" /> </div>' +
        "<h1>" +
        communityName +
        "</h1>" +
        "<p>" +
        detailAddress +
        ' </p><a href="https://www.google.com/maps?daddr=' +
        communityLat +
        "," +
        communityLong +
        '" target="_blank">Get driving directions</a>' +
        "</div>" +
        "</div>";
      directionsDisplay.setMap(map);
      var infowindow = new google.maps.InfoWindow({
        content: contentString,
      });
      var marker = new google.maps.Marker({
        position: locations,
        icon: "/assets/newUI-images/explore_icons/map_icon.svg",
        // icon: icon,
        map: map,
      });
      marker.addListener("click", function () {
        if (map) {
          infowindow.open(map, marker);
        }
        // infowindow.open( state.customMap, marker);
      });
    }
  };
  const typeView = async () => {
    $(".nav-link").removeClass("active");
    $("#name").addClass("active");
    updateState({
      showlist: false,
      showSearch: false,
    });
    methodx();
  };

  const distanceCal = (lat1, lon1, lat2, lon2, unit) => {
    var radlat1 = (Math.PI * lat1) / 180;
    var radlat2 = (Math.PI * lat2) / 180;
    var theta = lon1 - lon2;
    var radtheta = (Math.PI * theta) / 180;
    var dist =
      Math.sin(radlat1) * Math.sin(radlat2) +
      Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
    dist = Math.acos(dist);
    dist = (dist * 180) / Math.PI;
    dist = dist * 60 * 1.1515;
    if (unit == "K") {
      dist = dist * 1.609344;
    }
    if (unit == "N") {
      dist = dist * 0.8684;
    }
    return dist.toFixed(2);
  };

  const getDistance = async (location) => {
    const updatedLocations = [];

    for (let i = 0; i < location.length; i++) {
      const loc = location[i];
      let distanceVal = 0;

      if (
        loc.latitude !== "" &&
        loc.latitude !== undefined &&
        loc.latitude !== null &&
        loc.longitude !== "" &&
        loc.longitude !== undefined &&
        loc.longitude !== null
      ) {
        distanceVal = distanceCal(
          state.latitude,
          state.longitude,
          loc.latitude,
          loc.longitude
        );
      }

      // Add distance to the location object
      updatedLocations.push({
        ...loc,
        distance: parseFloat(distanceVal),
      });
    }

    // Sort by distance
    const sortedLocations = _.sortBy(updatedLocations, "distance");

    // Update the state once all calculations are done
    updateState({
      location: sortedLocations,
    });
  };

  const loadPlacesWithMarkers = async (index, type) => {
    const markers = [];

    const pyrmont = {
      lat: Number(state.latitude),
      lng: Number(state.longitude),
    };

    if (isNaN(pyrmont.lat) || isNaN(pyrmont.lng)) {
      console.error("Invalid coordinates:", pyrmont);
      return;
    }

    const mapElement = document.getElementById(
      "map" + state.communityObject.community_id
    );
    if (!mapElement) {
      console.error("Map container not found!");
      return;
    }

    const map = new google.maps.Map(mapElement, {
      zoom: 14,
      center: pyrmont,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      backgroundColor: "#eeeeee",
      disableDefaultUI: true,
    });

    const style = [
      {
        elementType: "geometry",
        stylers: [{ saturation: -40 }],
      },
    ];

    const mapType = new google.maps.StyledMapType(style, { name: "Grayscale" });
    map.mapTypes.set("grey", mapType);
    map.setMapTypeId("grey");

    const customZoomInControlDiv = document.createElement("div");
    CustomZoomInControl(customZoomInControlDiv, map);
    customZoomInControlDiv.index = 1;
    map.controls[google.maps.ControlPosition.LEFT_BOTTOM].push(
      customZoomInControlDiv
    );

    updateState({ map });

    const propertyMarker = new google.maps.Marker({
      map: map,
      position: pyrmont, // Using the same location as center
      icon: "/assets/newUI-images/explore_icons/map_icon.svg",
      zIndex: 999, // Keep property marker on top
    });

    // Add info window for property
    const propertyInfoWindow = new google.maps.InfoWindow();
    const propertyContent =
      '<div id="content">' +
      '<div id="siteNotice">' +
      "</div>" +
      '<div id="bodyContent">' +
      '<div class="bodycontentimg"><img width="100px" height="100px" src="' +
      state.communityObject.image_name +
      '" /> </div>' +
      "<h1>" +
      state.communityObject.community_name +
      "</h1>" +
      "<p>" +
      state.communityObject.address +
      ' </p><a href="https://www.google.com/maps?daddr=' +
      state.communityObject.latitude +
      "," +
      state.communityObject.longitude +
      '" target="_blank">Get driving directions</a>' +
      "</div>" +
      "</div>";

    google.maps.event.addListener(propertyMarker, "click", function () {
      propertyInfoWindow.setContent(propertyContent);
      propertyInfoWindow.open(map, propertyMarker);
    });

    // Store property marker
    updateState({
      propertyMarker: propertyMarker,
    });

    const service = new google.maps.places.PlacesService(map);
    const request = {
      location: pyrmont,
      radius: 2000,
      type: type,
    };

    service.nearbySearch(request, async (data, status) => {
      if (status === google.maps.places.PlacesServiceStatus.OK) {
        const location = [];
        const infowindow = new google.maps.InfoWindow();
        const results = _.orderBy(data, ["name"], ["asc"]);

        results.forEach((place, i) => {
          location.push({
            latitude: place.geometry.location.lat(),
            longitude: place.geometry.location.lng(),
            name: place.name,
            address: place.vicinity,
          });

          const marker = new google.maps.Marker({
            map,
            position: place.geometry.location,
            icon: state.types[index].icon,
          });

          google.maps.event.addListener(marker, "click", () => {
            const hasPhoto = place.hasOwnProperty("photos");
            const imageHTML = hasPhoto
              ? `<img src="${place.photos[0].getUrl()}" alt="Loading" width="160" height="80" />`
              : "";

            const contentString = `
              <h3 style="font-size:20px; text-align:center">${place.name}</h3>
              ${imageHTML}
              <div>
                <p>${place.vicinity}</p>
                <a href="https://www.google.com/maps/place/${place.vicinity}" target="_blank">Get Directions</a>
              </div>
            `;

            updateState({ activeNumber: place.name });
            infowindow.setContent(contentString);
            infowindow.open(map, marker);
          });

          markers.push(marker);
        });

        updateState({
          location: location,
          markerList: markers,
        });

        await getDistance(location);
      }
    });
  };

  const onetype = async (row, type) => {
    console.log(row.type, "row.type", type);

    $(".nav-link").removeClass("active");
    $("#" + row.name).addClass("active");
    updateState({
      type: row.type,
      showlist: true,
      typeName: row.name,
      typeicon: type,
      showSearch: false,
      location: [],
    });
    await loadPlacesWithMarkers(type, row.type);
  };
  const destinationLocation = () => {
    var address = "";
    const _this = this;
    var places = new google.maps.places.Autocomplete(
      document.getElementById("txtPlaces")
    );
    google.maps.event.addListener(places, "place_changed", function () {
      var place = places.getPlace();
      address = place.formatted_address;
      updateState({ destinationAdd: address });
    });
  };
  const searchPlace = () => {
    updateState({
      showSearch: true,
      showlist: true,
    });
  };
  const handleFormSubmit = async () => {
    await searchPlace();

    const locations = {
      lat: Number(state.communityObject.latitude),
      lng: Number(state.communityObject.longitude),
    };

    // Initialize map
    const customMap = new google.maps.Map(
      document.getElementById("map" + state.communityObject.community_id),
      {
        zoom: 7,
        center: locations,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        backgroundColor: "#eeeeee",
        disableDefaultUI: true,
        clickableIcons: false,
      }
    );

    // Grayscale map style
    const style = [
      {
        elementType: "geometry",
        stylers: [{ saturation: -40, visibility: "on" }],
      },
    ];

    const mapType = new google.maps.StyledMapType(style, { name: "Grayscale" });
    customMap.mapTypes.set("grey", mapType);
    customMap.setMapTypeId("grey");

    // Custom Zoom Control
    const customZoomInControlDiv = document.createElement("div");
    CustomZoomInControl(customZoomInControlDiv, customMap);
    customZoomInControlDiv.index = 1;
    customMap.controls[google.maps.ControlPosition.LEFT_BOTTOM].push(
      customZoomInControlDiv
    );

    updateState({ customMap });

    const directionsService = new google.maps.DirectionsService();

    const communityLat = Number(state.communityObject.latitude);
    const communityLong = Number(state.communityObject.longitude);

    const request = {
      origin: { lat: communityLat, lng: communityLong },
      destination: state.destinationAdd,
      travelMode: google.maps.DirectionsTravelMode.DRIVING,
    };

    directionsService.route(request, function (response, status) {
      if (status === google.maps.DirectionsStatus.OK) {
        // Render route
        new google.maps.DirectionsRenderer({
          map: customMap,
          directions: response,
          suppressMarkers: true,
        });

        const leg = response.routes[0].legs[0];

        // Commute info
        const distance = leg.distance.text;
        const duration = leg.duration.text;

        const dvDistance = document.getElementById("dvDistance");
        dvDistance.innerHTML = `
          <h4>Your Commute Summary</h4>
          <p>Drive Time: ${duration}</p>
          <p>Distance: ${distance}</p>
        `;

        // Start & End Marker Icons
        const icons = {
          start: new google.maps.MarkerImage(
            "/assets/newUI-images/explore_icons/map_icon.svg"
          ),
          end: new google.maps.MarkerImage(
            "https://suiteam-website.s3.us-west-1.amazonaws.com/new/icons/location_pin_2.svg"
          ),
        };

        // Marker Helper
        const makeMarker = (position, icon, title, map) =>
          new google.maps.Marker({
            position,
            map,
            icon,
            title,
          });

        // Place Markers
        makeMarker(leg.start_location, icons.start, "Start", customMap);
        makeMarker(leg.end_location, icons.end, "End", customMap);
      } else {
        console.error("Directions request failed due to:", status);
      }
    });
  };
  const flyToPlace = (row, index, type) => {
    var latLng = new google.maps.LatLng(row.latitude, row.longitude);
    state.map.panTo(latLng);
    const placemarker =
      type == "locations" ? state.markerList : state.placeSearchedMarkers;
    google.maps.event.trigger(placemarker[index], "click");
    updateState({ activeNumber: row.name });
  };
  const resetData = async () => {
    methodx();
  };
  var finalLocation = _.orderBy(state.location, ["name"], ["asc"]);
  return (
    <div className="SAweb_updateUi">
      <BlogHeader />
      <div className="starbucksInternsView">
        <div className="banner">
          <div className="container">
            <div className="view">
              <div className="item">
                <img
                  src="/assets/newUI-images/starbucks/startbuckLogo.png"
                  alt=""
                />
                <p className="text-white mb-0 mt-4">Welcome </p>
                <h2 className="text-white text-left">Starbucks Interns</h2>
                <p className="text-white">
                  SuiteAmerica is here to provide you with Furnished housing
                  during your Internship.
                </p>
              </div>
              <div className="item">
                <img
                  src="/assets/newUI-images/starbucks/bannerImage.png"
                  alt=""
                />
                {/* <img src="/assets/newUI-images/starbucks/banner-2.png" alt="" /> */}
              </div>
            </div>
          </div>
        </div>

        <div className="container my-5">
          <h3>{state.communityObject.community_name}</h3>
          <p>
            {state.communityObject.address != undefined
              ? state.communityObject.address
              : ""}
            ,{" "}
            {state.communityObject.city_name != undefined
              ? state.communityObject.city_name
                  .toLowerCase()
                  .split(" ")
                  .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
                  .join(" ")
              : ""}
            ,{" "}
            {state.communityObject.state_name != undefined
              ? state.communityObject.state_name
                  .toLowerCase()
                  .split(" ")
                  .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
                  .join(" ")
              : ""}{" "}
            {state.communityObject.ZipCode != undefined
              ? state.communityObject.ZipCode
              : ""}
          </p>
          {state.communityImages.length > 0 && (
            <div className="gallery mt-5">
              {state.communityImages.slice(0, 4).map((img, idx) => (
                <img key={idx} src={img.image_name} alt="" />
              ))}
            </div>
          )}
        </div>

        <div className="container">
          <h3>Amenities</h3>
          {state.communityAmenities.length > 0 ? (
            <div className="box-amenities mt-4 mb-5">
              {state.communityAmenities
                .filter(
                  (amenity) =>
                    !["dog park", "pet friendly"].includes(
                      amenity.aparment_amenity_name.toLowerCase()
                    )
                )
                .map((row, index) => {
                  return (
                    <div className="item" key={index}>
                      <img
                        width="55"
                        src={
                          s3BucketUrl +
                          "Amenities/" +
                          row.aparment_amenity_name.replace(
                            /[^A-Z0-9]+/gi,
                            ""
                          ) +
                          ".png"
                        }
                      />
                      <span>{row.aparment_amenity_name}</span>
                    </div>
                  );
                })}
            </div>
          ) : (
            <div
              className="text-center"
              style={{
                fontSize: "15px",
                width: "100%",
                margin: "auto",
                textAlign: "center",
              }}
            >
              No Amenities Found
            </div>
          )}

          <p className="text-left clickMore">
            {" "}
            Please
            <a
              href="https://stayinglevel.com/destinations/seattle/south-lake-union/amenities/lifestyle-amenities/ "
              target="_blank"
            >
              click here
            </a>
            to view more info on amenities and property map.
          </p>
        </div>

        <div class="shuttleInfo">
          <p class="text-white m-0">
            Please refer to the shuttle service information
          </p>
          <p class="text-white mb-4">
            provided by Starbucks for schedules and availability.
          </p>
          <button
            type="button"
            class="btn btn-primary px-5"
            data-toggle="modal"
            data-target="#exampleModal"
          >
            Shuttle Info
          </button>

          <div
            class="modal modal-fullscreen-xl modal fade animated tab-modal guest-Ui SAweb_modalPoup"
            id="exampleModal"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog" role="document">
              <div class="modal-content">
                <button
                  type="button"
                  class="btn close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <i class="bi bi-x"></i>
                </button>
                <div class="modal-body">
                  <iframe
                    src={
                      "https://suiteam-website.s3.us-west-1.amazonaws.com/PDF/SSC+Shuttle+Schedule.pdf"
                    }
                    width="100%"
                    height="100%"
                    frameBorder="0"
                    allowFullScreen
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="SAweb_neighbourhood py-5">
          <div className="container  ">
            <h3 className="ps-3">Neighborhood</h3>
            <ul className="nav nav-tabs mt-4">
              <li>
                <button
                  className="nav-link active"
                  onClick={() => typeView()}
                  id="name"
                  data-toggle="tab"
                  data-target="#commute"
                  type="button"
                  role="tab"
                  aria-controls="commute"
                  aria-selected="false"
                >
                  Commute
                </button>
              </li>
              {state.types.map((row, index) => {
                return (
                  <li key={index} onClick={() => onetype(row, index)}>
                    <button
                      className="nav-link "
                      id={row.name}
                      aria-selected="true"
                    >
                      {row.name}
                    </button>
                  </li>
                );
              })}
            </ul>

            <div className="tab-content myTabContentVIew">
              <div
                className="tab-pane fade in active"
                id="commute"
                role="tabpanel"
                aria-labelledby="commute-tab"
              >
                <div className=" ">
                  {state.showlist && !state.showSearch ? (
                    <div className="">
                      <ul className="distanceList">
                        {finalLocation.map((row, index) => {
                          return (
                            <li
                              className={
                                state.activeNumber == row.name
                                  ? "item test"
                                  : "item"
                              }
                              key={index}
                              onClick={() =>
                                flyToPlace(row, index, "locations")
                              }
                            >
                              <p>
                                {" "}
                                {row.name} <span>{row.address}</span>{" "}
                              </p>
                              <p> {row.distance} mi</p>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  ) : (
                    <div className="tabsView">
                      <h3>What’s My Commute?</h3>
                      <input
                        type="text"
                        id="txtPlaces"
                        placeholder="Enter a location"
                        onChange={() => destinationLocation()}
                      />
                      <div className="view-btns">
                        <button
                          type="button"
                          className="btn black-btn"
                          onClick={() => handleFormSubmit()}
                        >
                          Search
                        </button>
                        <button
                          type="button"
                          className="btn black-btn"
                          onClick={() => resetData()}
                        >
                          Reset
                        </button>
                      </div>
                      <div id="dvDistance"></div>
                    </div>
                  )}

                  <div
                    id={"map" + state.communityObject.community_id}
                    className="map-alignment"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="contactUs text-white">
          <i class="bi bi-envelope-open"></i>
          <p class="text-white m-0">
            Got Questions? Contact us at
            <a href="mailto:starbucksinterns@suiteamerica.com">
              starbucksinterns@suiteamerica.com
            </a>
          </p>
        </div>

        <div className="container py-5">
          <h3>FAQ</h3>

          <div className="faqBtns">
            {["In-Suite", "General"].map((label, i) => (
              <button
                key={label}
                className={`btn black-btn me-5  ${
                  state.generalTab === !!i ? "active" : ""
                }`}
                onClick={() => updateState({ generalTab: !!i })}
              >
                {label}
              </button>
            ))}
          </div>

          <div
            id="accordion"
            className="panel-group company_acdn faqView mt-4"
            role="tablist"
            aria-multiselectable="true"
          >
            {(state.generalTab ? GeneralFaq : SuiteFaq).map((row, index) => (
              <div className="panel panel-default" key={index}>
                <div className="panel-heading">
                  <h4 className="panel-title">
                    <a
                      className="collapsed"
                      data-toggle="collapse"
                      data-parent="#accordion"
                      href={`#collapse${index}`}
                      aria-expanded="false"
                      aria-controls={row.id}
                    >
                      {row.Question}
                    </a>
                  </h4>
                </div>
                <div
                  id={`collapse${index}`}
                  className="panel-collapse collapse"
                >
                  <div className="panel-body">
                    <ul className="answer-list">
                      {row.Answer.map((line, i) => (
                        <li key={i}>{line}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default StartBucksIntership;
